import { render } from "./intermedio.vue?vue&type=template&id=f5afcaec&scoped=true"
import script from "./intermedio.vue?vue&type=script&lang=js"
export * from "./intermedio.vue?vue&type=script&lang=js"

import "./intermedio.vue?vue&type=style&index=0&id=f5afcaec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5afcaec"]])

export default __exports__